import {Injectable} from '@angular/core';

export interface IAbout {
  img: string;
  header: string;
  description: string;
  num: string;
}

@Injectable({
  providedIn: 'root'
})
export class AboutUsService {

  data = [
    {
      img: 'assets/img/about-icon.png',
      header: 'Scientific Accuracy',
      description: 'Anima combines eye-tracking technology with well-established psychometric tests and analyzes the biomarkers of attention. This fusion of technology and science enables a more accurate assessment of mental states such as anxiety, depression, and stress levels, even in environments where self-reporting may be unreliable.',
      num: '01'
    },
    {
      img: 'assets/img/about-icon.png',
      header: 'Personalized Insights',
      description: 'Anima\'s unique approach doesn\'t just identify potential mental health challenges; it offers personalized insights and recommendations. By understanding individual gaze patterns and mental states, Anima can provide tailored strategies for improving mental well-being.',
      num: '02'
    },
    {
      img: 'assets/img/about-icon.png',
      header: 'Privacy and Security',
      description: 'With a strict focus on privacy, Anima only utilizes the camera for gaze detection, recording only gaze coordinates. There are no videos or images stored, and stringent data protection protocols are in place to safeguard personal information.',
      num: '03'
    },
    {
      img: 'assets/img/about-icon.png',
      header: 'Accessibility and Convenience',
      description: 'As an online service, Anima is readily accessible to anyone looking to understand and enhance their mental health. Its user-friendly platform makes mental state monitoring a seamless part of daily well-being management.',
      num: '04'
    }
  ];

  constructor() {
  }

  getList() {
    return this.data;
  }

  private createItem(prop: IAbout): IAbout {
    return {
      img: prop.img,
      header: prop.header,
      description: prop.description,
      num: prop.num
    };
  }
}
